
function confirmation(callback,id,message){
	var c = confirm(message);
	if(c){
		callback(id);
	}
}

function initContactForm(){
	var contact_form = $('form[name="contact-form"]').validate({
		submitHandler: function() {
			$.ajax({data:$('form[name="contact-form"]').serialize(), 
					success:function(data) {
						if(data.status == "ok"){
							$("input:text").val("");
							$("textarea").val("");
							form_submit_response('form[name="contact-form"]','success',data.message);
						}else if(data.status == 'error') {
							form_submit_response('form[name="contact-form"]','error',data.error);
						}else{
							form_submit_response('form[name="contact-form"]','error','An unknown error occured. Please try again later');
						}
					}
			});
			return false;
		},
		rules: {
			fname		: "required",
			lname		: "required",
			message		: "required",
			email		: {
				required: true,
				email: true
			}
			
			
		},		 
		highlight: function (element, errorClass, validClass) {
			$(element).parent().find('.form-control-feedback').remove();
			$(element).closest('.form-group').append('<span class=" form-control-feedback"></span>');
			$(element).parent().addClass('has-error has-feedback');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).parent().find('.form-control-feedback').remove();
            $(element).parent().removeClass('has-error has-feedback');
        },
		messages:{
			fname		: "We need to call you something... :)",
			lname		: "Need this to set you apart from the crowd..",
			email		: "Please enter a valid email",
			message		: "You must have something to say...."
		},
		errorPlacement: function(error, element) {
			element.parent().find('.form-control-feedback').html(error);
		}
	});
}

function form_submit_response(target,type,message,r){
	"use strict";	
	var redirect = r || false;
	var markup = '';
	$('.alert').remove();
	
	if(type==="error"){
		markup = '<div class="alert alert-error">\
					  <button type="button" class="close" data-dismiss="alert">&times;</button>\
					  '+message+'\
					</div>';
	}else if(type=='success'){
		markup = '<div class="alert alert-success">\
				  <button type="button" class="close" data-dismiss="alert">&times;</button>'+message+'\
				</div>';
		if(type == 'success' && redirect){
			setTimeout(function(){window.location.reload();},5000);
		}
	}else{
	}
	$(target).closest('form').prepend(markup);
}
